<template>
    <div class="header-loading">
        <div class="header-loading__left">
            <p class="header-loading__left-bread" />
            <p class="header-loading__left-logo" />
            <p class="header-loading__left-links" />
        </div>
        <div class="header-loading__right">
            <p class="header-loading__right-help" />
            <p class="header-loading__right-avatar" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeaderLoading'
};
</script>

<style lang="scss">
    .header-loading {
        height: 64px;
        width: 100%;
        padding: 0 24px;
        position: relative;
        &__left, &__right {
            display: table-cell;
            vertical-align: middle;
            font-size: 0;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            p {
                background-color: #ebecf0;
                display: inline-block;
                vertical-align: middle;
            }
        }
        &__left {
            left: 24px;
            &-bread {
                height: 16px;
                width: 16px;
                margin-right: 16px !important;
            }
            &-logo {
                height: 25px;
                width: 118px;
                margin-right: 32px !important;
            }
            &-links {
                height: 25px;
                width: 56px;
            }
        }
        &__right {
            right: 24px;
            &-help {
                height: 25px;
                width: 35px;
                margin-right: 16px !important;
            }
            &-avatar {
                height: 40px;
                width: 40px;
            }
        }
    }
</style>
